import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { fetchPartnerAccountById } from '../queries/ppc-queries/fetch-partner-account-by-id';

export const useGetPartnerAccountById = ({
  partnerAccountId,
  skip = false,
}: {
  partnerAccountId: string;
  skip?: boolean;
}) => {
  const ppcBffClient = useMemo(() => abgGraphqlClient(ProxyGraphClients.PPC_BFF), []);

  const { data, loading, error } = useQuery(fetchPartnerAccountById, {
    variables: {
      id: partnerAccountId,
    },
    skip: !partnerAccountId || skip,
    client: ppcBffClient,
  });

  const partnerAccountDetails = data?.partnerAccount;

  return { partnerAccountDetails, partnerAccountDetailsLoading: loading, partnerAccountDetailsError: error };
};
